


















































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { useTranslate } from "@/plugins/translate";
// local
import { default as FBInstructions } from "./fb-instructions.vue";

export default defineComponent({

	emits:[],
	props:{
	},
	components:{
		"fb-instructions":FBInstructions,
	},
	setup(props, context){

		const {
			translate,
		} = useTranslate(context);
		
		const title = computed(() => {
			// return "...hang on!";
			return translate("fb_warningTitle");
		});
		
		const subtitle = computed(() => {
			// return `You appear to be visiting through <span class="font-weight-bold">facebook</span>.`;
			return translate("fb_notify");
		});

		const description = computed(() => {
			// return `For our site to work correctly (and to prevent facebook looking over your shoulder) please switch to your normal browser.`
			return translate("fb_explain");
		});

		return {
			title,
			subtitle,
			description,
		};
	}
});

